import { policyRuleDisplayMessagePlacements } from '@reveni-io/reveni-ui'

import { customMessageTypeValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/CustomMessage/constants'

export const productDialogPlacements = [
  policyRuleDisplayMessagePlacements.productRequestTypeSelectionDialog,
  policyRuleDisplayMessagePlacements.productReturnReasonSelectionDialog,
  policyRuleDisplayMessagePlacements.productRequestTypeConfirmationDialog,
]

export const pagePlacementOptions = [
  { value: policyRuleDisplayMessagePlacements.productsPage, labelKey: 'Página de productos' },
  { value: policyRuleDisplayMessagePlacements.returnMethodPage, labelKey: 'Página de método de devolución' },
  { value: policyRuleDisplayMessagePlacements.refundMethodPage, labelKey: 'Página de método de reembolso' },
  { value: policyRuleDisplayMessagePlacements.finalConfirmationPage, labelKey: 'Página de confirmación final' },
]

const productDialogPlacementOptions = [
  {
    value: policyRuleDisplayMessagePlacements.productRequestTypeSelectionDialog,
    labelKey: 'Producto - Selección de tipo de solicitud',
  },
  {
    value: policyRuleDisplayMessagePlacements.productReturnReasonSelectionDialog,
    labelKey: 'Producto - Selección de motivo de devolución',
  },
  {
    value: policyRuleDisplayMessagePlacements.productRequestTypeConfirmationDialog,
    labelKey: 'Producto - Confirmación de solicitud',
  },
]

export const messagePlacementOptions = [...pagePlacementOptions, ...productDialogPlacementOptions]

export const customMessageTypeOptions = [
  customMessageTypeValues.info,
  customMessageTypeValues.warning,
  customMessageTypeValues.error,
  customMessageTypeValues.success,
]
